import { queryClient } from "@/client";
import { buildCompanySelectionCombined } from "@/utils/searchRequestBuilder.util";
import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { useMutation } from "@tanstack/react-query";

import { listsQueryKey } from "@/hooks/api/list/useInfiniteLists";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export type StaticListCreate = {
  name: string;
  items: (CompanyEntryDto | string)[];
};

export const useCreateList = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: StaticListCreate) => {
      return apiClient.listsStatic.create({
        requestBody: { name: requestBody.name, items: buildCompanySelectionCombined(requestBody.items) },
      });
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [listsQueryKey] }),
  });

  return {
    ...mutation,
    createList: mutation.mutate,
  };
};
